import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(360deg)
  }
`

/*
 * We calculate the border width by multiplying it with a magic number.
 * This magic number is the result of dividing the original border width
 * with the default diameter.
 */
const calculateBorderWidth = (diameter) => diameter * 0.005

const SpinnerComponent = styled.div`
  border-top: ${(props) => calculateBorderWidth(props.diameter)}em solid
    ${(props) => props.backgroundColor};
  border-right: ${(props) => calculateBorderWidth(props.diameter)}em solid
    ${(props) => props.backgroundColor};
  border-bottom: ${(props) => calculateBorderWidth(props.diameter)}em solid
    ${(props) => props.backgroundColor};
  border-left: ${(props) => calculateBorderWidth(props.diameter)}em solid
    ${(props) => props.foregroundColor};
  border-radius: 50%;
  width: ${(props) => props.diameter}px;
  height: ${(props) => props.diameter}px;
  animation: ${rotate} 1.1s linear infinite;
`

SpinnerComponent.defaultProps = {
  diameter: 100,
  backgroundColor: '#787878',
  foregroundColor: '#1cc75b',
}

export default SpinnerComponent
